@if (formField(); as field) {
  <app-textarea
    [color]="hasError() ? 'red' : 'primary'"
    [label]="field.label"
    [(value)]="value"
    [required]="field.required!"
    [disabled]="field.disabled!"
    [placeholder]="_placeholder()"
    [maxlength]="field.maxlength"
    [height]="field.height ? field.height.toString() : ''"
    [labelPosition]="field.labelPosition!"
  />
}
